/** What a capped multi-select holds against its cap, and what to do once it is full. */
export const selectionBudget = (held: number, max: number): string => {
  const tally = `${held} of ${max} selected`;
  return held >= max ? `${tally} — remove one to add another` : tally;
};
